import { render } from "./UnauthenticatedUserFollowProjectForm.vue?vue&type=template&id=6468a002"
import script from "./UnauthenticatedUserFollowProjectForm.vue?vue&type=script&lang=js"
export * from "./UnauthenticatedUserFollowProjectForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__